/**
 * D30DivisionsTable Component
 * Container for two D30 division systems with expandable sections
 */

import React from 'react';
import { JatakaResponse } from '../../../../../models/api';
import { ExpandableSectionsContainer, ExpandableSection } from './ExpandableSectionsContainer';
import { BhriguTrimsamshaInfoTable } from './BhriguTrimsamshaInfoTable';
import { MuhurtaInfoTable } from './MuhurtaInfoTable';

export interface D30DivisionsTableProps {
  apiResponse?: JatakaResponse | null;
}

export const D30DivisionsTable: React.FC<D30DivisionsTableProps> = ({ apiResponse }) => {
  const sections: ExpandableSection[] = [
    {
      storageKey: 'd30-bhrigu-expanded',
      label: 'Bhrigu Trimsamsha',
      component: <BhriguTrimsamshaInfoTable apiResponse={apiResponse} />,
    },
    {
      storageKey: 'd30-muhurta-expanded',
      label: 'Muhurta',
      component: <MuhurtaInfoTable apiResponse={apiResponse} />,
    },
  ];

  return <ExpandableSectionsContainer sections={sections} />;
};
